(() => {
  let busy = false;
  let attempts = 0;
  let timer;
  const incomplete = () => document.querySelector('[data-milagro-incomplete-item]');
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(check, 150);
  };
  async function check() {
    if (busy) return;
    if (!incomplete()) { attempts = 0; return; }
    document.querySelectorAll('[name="checkout"]').forEach(button => {
      button.disabled = true;
      button.setAttribute('data-milagro-checkout-blocked', '');
    });
    if (attempts >= 2) return;
    busy = true;
    attempts++;
    try {
      const main = document.querySelector('cart-items');
      const drawer = document.querySelector('cart-drawer');
      const sections = main ? main.getSectionsToRender().map(s => s.section) : ['cart-drawer'];
      const root = window.Shopify?.routes?.root || '/';
      const options = {cache:'no-store',signal:AbortSignal.timeout(5000)};
      const [cartResponse, sectionsResponse] = await Promise.all([
        fetch(root + 'cart.js', options),
        fetch(root + '?sections=' + encodeURIComponent([...new Set(sections)].join(',')), options)
      ]);
      if (!cartResponse.ok || !sectionsResponse.ok) return;
      const cart = await cartResponse.json();
      const rendered = await sectionsResponse.json();
      if (sections.some(id => typeof rendered[id] !== 'string')) return;
      const state = {...cart,sections:rendered};
      if (main) main.renderContents(state);
      else if (drawer) drawer.renderContents(state, true, false);
      document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart:state}}));
    } catch (error) {
      console.warn('Cart details could not be refreshed', error);
    } finally {
      busy = false;
      if (incomplete() && attempts < 2) timer = setTimeout(check, 500);
    }
  }
  document.addEventListener('click', event => {
    if (incomplete() && event.target.closest('[name="checkout"],a[href$="/checkout"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      schedule();
    }
  }, true);
  document.addEventListener('submit', event => {
    if (incomplete() && event.submitter?.name === 'checkout') {
      event.preventDefault();
      event.stopImmediatePropagation();
      schedule();
    }
  }, true);
  new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true});
  schedule();
})();
